import React, { useEffect } from "react";
import LogoMark from "../../gallery/default/logomark.png";
import { useState } from "react";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { setUser, setSignup, setGuest } from "../../app/features/user/userSlice";
import { BeatLoader } from "react-spinners";
import CountdownTimer from "./CountdownTimer";

function EventLoginForm({ createBooking }) {
  const cart = useSelector((state) => state.event.cart);
  const currentEvent = useSelector((state) => state.event.currentEvent);
  const isTimer = useSelector((state) => state.timer.isTimer);

  const dispatch = useDispatch();

  const [passwordError, setPasswordError] = useState(null);
  const [emailError, setEmailError] = useState(null);
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  function isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  useEffect(() => {
    setTimeout(() => {
      const emailInput = document.querySelector('input[name="email"]');
      const passwordInput = document.querySelector('input[name="password"]');

      const email = emailInput && emailInput.value ? emailInput.value.trim() : "";
      const password = passwordInput && passwordInput.value ? passwordInput.value.trim() : "";

      if (email || password) {
        setFormData({ email, password });
      }
    }, 500);
  }, []);

  const handleEmail = (event) => {
    setFormData({
      ...formData,
      [event.target.name]: event.target.value,
    });
    if (!isValidEmail(event.target.value)) {
      setEmailError("Please enter a valid email!");
      setTimeout(() => {
        setEmailError(null);
      }, 5000);
    }
  };
  const handlePassword = (event) => {
    const password = event.target.value;
    setFormData({
      ...formData,
      [event.target.name]: password,
    });
    const inputEmail = document.getElementsByName("email");
    const firstInputElement = inputEmail[0];
    if (password.length < 6) {
      setPasswordError("Password must be atleast 6 character!");
      setTimeout(() => {
        setPasswordError(null);
      }, 5000);
    } else if (!isValidEmail(formData.email)) {
      setPasswordError("Please enter a valid email!");
      firstInputElement.focus();
      setTimeout(() => {
        setPasswordError(null);
      }, 5000);
      return;
    }
  };

  const login = async (event) => {
    event.preventDefault();
    const loginButton = event.target;
    loginButton.classList.remove("btn-login");
    loginButton.classList.add("btn-disable-login");
    const loader = document.getElementById("loader");
    loader.style.display = "block";

    if (formData.email === "") {
      setEmailError("Please enter a valid email!");
      setTimeout(() => {
        setEmailError(null);
        loader.style.display = "none";
        loginButton.classList.remove("btn-disable-login");
        loginButton.classList.add("btn-login");
      }, 5000);
      return;
    } else if (formData.password === "") {
      setPasswordError("Password must be atleast 6 character!");
      setTimeout(() => {
        setPasswordError(null);
        loader.style.display = "none";
        loginButton.classList.remove("btn-disable-login");
        loginButton.classList.add("btn-login");
      }, 5000);
      return;
    }

    try {
      await axios.request({
        method: "GET",
        url: `${process.env.REACT_APP_BASE_URL}/api/sanctum/csrf-cookie`,
      });

      const response = await axios.request({
        method: "POST",
        url: `${process.env.REACT_APP_BASE_URL}/api/login`,
        data: formData,
      });

      const userData = response.data.data;

      if (userData.name) {
        const nameParts = userData.name.trim().split(" ");
        userData.first_name = nameParts[0];
        userData.last_name = nameParts.slice(1).join(" ");
      }

      dispatch(setUser(userData));

      const bookingLoader = document.getElementById("bookingloader");
      bookingLoader.style.display = "block";
      await createBooking({}, false, userData);

      loader.style.display = "none";
      loginButton.classList.remove("btn-disable-login");
      loginButton.classList.add("btn-login");
    } catch (error) {
      console.log("Here is the Error", error);
      setEmailError((error.response && error.response.data && error.response.data.message) || "Login failed");
      setTimeout(() => {
        setEmailError(null);
        loader.style.display = "none";
        loginButton.classList.remove("btn-disable-login");
        loginButton.classList.add("btn-login");
      }, 5000);
    }
  };
  const goToSignup = (event) => {
    event.preventDefault();
    dispatch(setSignup());
  };
  const goToGuest = (event) => {
    event.preventDefault();
    dispatch(setGuest());
  };

  return (
    <div className="login-container">
      <div className="row">
        <div className="col-12">
          <div className="col-12 d-flex justify-content-center mb-2">
            <img src={LogoMark} alt="Sahi Search" />
          </div>
          {isTimer && <CountdownTimer />}
          <p className="not-reserved">Tickets are not reserved until you have completed payment.</p>
          <h3 className="login-event-title">{currentEvent.name}</h3>
          <p className="ticket-waiting">
            {cart.productsCount}&nbsp;
            {cart.productsCount === 1 ? "ticket waiting" : "tickets waiting"}
          </p>
          <p className="inclusive-fee">All ticket prices are inclusive of booking fees</p>
          <h3 className="grand-total">
            {cart.discount > 0 && <span className="discount-applied-success">£{cart.subTotal.toFixed(2)}</span>}
            &nbsp; £{cart.grandTotal.toFixed(2)}
          </h3>
          <div className="d-flex justify-content-center">
            <button className="btn btn-blue" onClick={(event) => goToGuest(event)}>
              Checkout as Guest
            </button>
          </div>
          <h3 className="login-heading">or log in to continue</h3>

          <form className="row g-3" autoComplete="off">
            <div className="col-12">
              <label htmlFor="staticEmail2" className="form-label input-label">
                Email
              </label>
              <input type="email" className={`form-control input-text-size ${emailError ? "error-input" : ""}`} placeholder="Enter your email" defaultValue={formData.email} name="email" onBlur={handleEmail} />
              {emailError && <p className="error-text mb-0">{emailError}</p>}
            </div>
            <div className="col-12">
              <label htmlFor="inputPassword2" className="form-label input-label">
                Password
              </label>
              <input type="password" className={`form-control input-text-size ${passwordError ? "error-input" : ""}`} name="password" placeholder="Enter you password" defaultValue={formData.password} onBlur={handlePassword} />
              {passwordError && <p className="error-text mb-0">{passwordError}</p>}
            </div>
            {/* <div className="col-12">
              <a href="/" className="forgot-password mb-3">
                Forgot passowrd
              </a>
            </div> */}
            <div className="col-12 text-center mt-4">
              <button id="logindefaultbtn" type="button" className={emailError || passwordError ? "btn btn-disable-login mb-3" : "btn btn-login mb-3"} onClick={login}>
                Sign in
              </button>
              <div id="loader" style={{ display: "none" }}>
                <BeatLoader color="#C6153B" />
              </div>
              <div id="bookingloader" style={{ display: "none" }}>
                <BeatLoader color="#C6153B" />
                <h4 className="mt-3" style={{ color: "#C6153B" }}>
                  Creating Booking...
                </h4>
              </div>
            </div>
            <div className="col-12">
              <p className="account">
                Don't have an account?{" "}
                <span>
                  <a href="/" className="sign-up" onClick={(event) => goToSignup(event)}>
                    Sign up
                  </a>
                </span>
              </p>
            </div>
          </form>
        </div>
        <div className="col-lg-6 col-md-12 col-sm-12 col-12">
          <div className="event-align-middle"></div>
        </div>
      </div>
    </div>
  );
}

export default EventLoginForm;
